import React, { useState, useContext, useEffect } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import FormBuilder from "../FormBuilder/FormBuilder";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import { EWContext } from "../../../context/EWContext";
import { getFormAnswers } from "../../../utils/utils";
import { SUBTITLE_TEXT_SCHEDULE } from "../../../constants";

function ScheduleQuestionsForm(props) {
    const [accountState, setAccountState] = useContext(
        EWContext
    );

    const {
        questions: {
          schedule: questions
        },
        answers: {
          schedule: scheduleAnswers
        },
        conditionSpecificBehaviors
    } = accountState;

    const [loading, setLoading] = useState(false);
    const [errorFields, setErrorFields] = useState(true);
    const [scheduleFormAnswers, setscheduleAnswers] = useState(
        scheduleAnswers
    );
    const { handleNext, handleBack } = props;
    const { jobTypeSubtitle } = accountState.skeduloInfo;

    useEffect(() => {
        if (scheduleAnswers.length > 0) {
            const formIsAnswered = scheduleAnswers.every((field) =>
                field ? (field.required ? field.value !== "" : true) : false
            );
            if (formIsAnswered) {
                setErrorFields(false);
            }
        }
    }, [scheduleAnswers]);

    const handleOnFormAnswered = (answers) => {
        const formIsAnswered = getFormAnswers(answers, questions).every(
            (field) => {
                if(field.type === "date") {
                    if(field.value == "Invalid Date") {
                      return false
                    }
                    let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;

                    if(dateRange?.minDate?.date) {

                        if(new Date(field.value ) < new Date(dateRange.minDate.date)){
                            return false
                        }
                    } 

                    if(dateRange?.maxDate?.date) {
                        if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
                            return false
                        }
                    }
                }
                return field.required ? field.value !== "" : true;
            }
        );
        if (formIsAnswered) {
            setErrorFields(false);
            const scheduleAnswers = getFormAnswers(answers, questions);
            setscheduleAnswers(scheduleAnswers);
        } else {
            setErrorFields(true);
        }
    };

    const handleSubmit = (evt) => {
        setLoading(true);
        evt.preventDefault();
        setAccountState((prevAccountState) => ({
            ...prevAccountState,
            answers: {
              ...prevAccountState.answers,
              schedule: [...scheduleFormAnswers]
            }
        }));
        setLoading(false);
        handleNext(true);
    };

    return (
        <FormBuilder
            questions={questions}
            answers={scheduleAnswers}
            onFormAnswered={handleOnFormAnswered}
            handleSubmit={handleSubmit}
            formInstructions={"Schedule your appointment"}
            requiredFieldsSubtitule={true}
            subtitleText={
              conditionSpecificBehaviors?.cr_appointment_label
              ? `${conditionSpecificBehaviors?.SUBTITLE_TEXT_SCHEDULE_APPOINTMENT}${conditionSpecificBehaviors?.cr_assessment_name}`
              : `${jobTypeSubtitle || SUBTITLE_TEXT_SCHEDULE}`}
        >
            <StepperNavigationButtons
                handleBack={handleBack}
                handleNext={() => null}
                loading={loading}
                nextButtonDisabled={errorFields}
            />
        </FormBuilder>
    );
}

export default withErrorHandler(ScheduleQuestionsForm);
